export type IntervalOption = { value: string; label: string };

/**
 * Build sensible interval options given a total range span in milliseconds.
 * Mirrors the logic previously inline in DataPage.computeIntervalOptions.
 */
export function computeIntervalOptionsFromRange(spanMs: number): IntervalOption[] {
  const day = 24 * 60 * 60 * 1000;
  const month = 30 * day;
  const year = 365 * day;

  if (spanMs <= day) {
    return [
      { value: '30m', label: '30m' },
      { value: '1h', label: '1h' },
      { value: '2h', label: '2h' },
      { value: '3h', label: '3h' },
      { value: '6h', label: '6h' },
    ];
  }
  if (spanMs <= month) {
    return [
      { value: '6h', label: '6h' },
      { value: '12h', label: '12h' },
      { value: '24h', label: '1d' },
      { value: '48h', label: '2d' },
    ];
  }
  if (spanMs <= year) {
    return [
      { value: '24h', label: '1d' },
      { value: '48h', label: '2d' },
      { value: '168h', label: '7d' },
      { value: '336h', label: '14d' },
      { value: '1mo', label: '1M' },
    ];
  }
  // Multi-year
  return [
    { value: '168h', label: '7d' },
    { value: '336h', label: '14d' },
    { value: '1mo', label: '1M' },
  ];
}
